<p class="m-4 font-bold text-lg" *ngIf="isComparisonYear">{{ 'dashboard.comparison_year' | transloco }} {{year}}</p>
<p class="m-4 font-bold text-lg" *ngIf="!isComparisonYear">{{ 'dashboard.analysis_year' | transloco }} {{year}}</p>
<div class="w-full border-border border-[1px]"></div>
<div class="m-4 flex justify-between mt-4">
    <p class="text-neutral-500">{{ 'dashboard.last_full_month' | transloco }} :</p>
    <div class="flex flex-col">
        <p class="font-bold">{{ lastFullMonthCost !== null && lastFullMonthCost !== undefined ? (lastFullMonthCost |
            number:'1.0-0') : 0 }}Є</p>
        <p class="font-bold">{{ lastFullMonthkWh !== null && lastFullMonthkWh !== undefined ? (lastFullMonthkWh |
            number:'1.0-0') : 0 }} {{unit}}</p>
    </div>
</div>



<div class="m-4 flex justify-between mt-4">
    <p class="text-neutral-500">{{ 'dashboard.year_to_date' | transloco }} :</p>
    <div class="flex flex-col">
        <p class="font-bold">{{ yearToDateCost !== null && yearToDateCost !== undefined ? (yearToDateCost |
            number:'1.0-0') : 0 }}Є</p>
        <p class="font-bold">{{ yearToDatekWh !== null && yearToDatekWh !== undefined ? (yearToDatekWh | number:'1.0-0')
            : 0 }} {{unit}}</p>
    </div>
</div>

<div class="m-4 flex justify-between mt-4">
    <p class="text-neutral-500">{{ 'dashboard.forecast_full_year' | transloco }} :</p>
    <div class="flex flex-col" *ngIf="!showUpgrade">
        <p class="font-bold">{{ forecastFullYearCost !== null && forecastFullYearCost !== undefined ?
            (forecastFullYearCost | number:'1.0-0') : 0 }}Є</p>
        <p class="font-bold">{{ forecastFullYearkWh !== null && forecastFullYearkWh !== undefined ? (forecastFullYearkWh
            | number:'1.0-0') : 0 }} {{unit}}</p>
    </div>
    <div *ngIf="showUpgrade">
        <a routerLink="/settings/plans" class="text-black"><span class="underline font-bold">{{ 'shared.upgrade' |
                transloco}}</span> {{ 'shared.to_see_forecast_data' | transloco}}</a>
    </div>
</div>